





























































































import Vue from 'vue'
import { getMobileTheme } from '../../helper'

export default Vue.extend({
  methods: {
    updateActiveLibrary(val: string) {
      this.$store.commit('UPDATE_ACTIVE_LIBRARY', val)
      window.scrollTo(0, 0)
    },
    getMobileTheme
  },
  computed: {
    libraryPath(): string {
      return 'library-v2'
    },
    active(): string {
      return this.$store.getters.activeLibrary
    },
    newMobileScreens(): boolean {
      return this.$store.getters.newMobileScreens
    },
    renderComponent(): boolean {
      const renderRoutes = ['library-v2', 'category-overview', 'category-list']
      const routeName = this.$route.name
      if (this.newMobileScreens && renderRoutes.find(r => r === routeName)) {
        return true
      }
      return false
    }
  }
})
